import { createSlice } from '@reduxjs/toolkit';
import { Status } from 'ui-widgets';
import { getBrandsThunk } from '../../api/brands';
import { getBrandLink } from '../../helpers';

export interface Brand {
  status: string;
  id: string;
  store_id: string;
  menu_visibility: string;
  visibility_type: string;
  featured: string;
  coming_soon: string;
  type: string;
  manufacturer_id: string;
  manufacturer_name: string;
  header_logo: string;
  header_image: string;
  header_image_tablet_landscape: string;
  header_image_tablet_portrait: string;
  header_image_phone: string;
  url: string;
  intro_text: string;
  search_for_button: string;
  about_text: string;
  our_process: string;
  video_link: string;
  video_placeholder: string;
  contact: string;
  categories: string;
  cdu_manufacturer_filter: string;
  analytics: string;
  created_at: string;
  collection_button: string;
  member_type: string;
  primary_category: string;
  use_project_name_widget_order: string;
  skip_third_part_integration: string;
  hd_min_qty: string;
  hd_max_qty: string;
  dashboard_leads_email: string;
  dashboard_code_for_leads: string;
  brand_shipment_require_serial: string;
}

export interface BrandsState {
  brands: Brand[];
  status: Status;
  error: null | string;
  filterValue: string;
}

export const initialState: BrandsState = {
  brands: [],
  status: Status.IDLE,
  error: null,
  filterValue: '',
};

const brandsSlice = createSlice({
  name: 'brandsSlice',
  initialState,
  reducers: {
    setFilterValue(state, { payload }) {
      state.filterValue = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBrandsThunk.pending, (state) => {
        state.status = Status.LOADING;
      })
      .addCase(getBrandsThunk.fulfilled, (state, { payload }) => {
        const activeBrands = payload.filter(
          (brand) => brand.status !== '0' && brand.menu_visibility !== '0',
        );
        const brandsWithCorrectLinks = activeBrands.map((brand) => ({
          ...brand,
          search_for_button: getBrandLink(brand.search_for_button),
        }));
        state.status = Status.LOADED;
        state.brands = brandsWithCorrectLinks;
      })
      .addCase(getBrandsThunk.rejected, (state, { payload }) => {
        state.status = Status.ERROR;
        state.error = payload?.message || null;
      });
  },
});

export const { setFilterValue } = brandsSlice.actions;

export default brandsSlice.reducer;
